import React from "react";

import { HeartFillIcon, CpuIcon } from "@primer/octicons-react";
import { Link } from "react-router-dom";

import { APP_VERSION } from "./../../services/constants";

export default function Footer() {
  return (
    <>
      <footer>
        <span className="d-block text-center">
          Made with <HeartFillIcon size={16} className="heart-icon" /> by ICT
          Campus <br />
          <br />
          <Link to="/impress/">Mehr Informationen</Link>
        </span>
        <div className="mt-3 mb-2">
          <small className="text-center d-block">
            <AppVersion /> {APP_VERSION.FRONTEND.VERSION} •{" "}
            {APP_VERSION.BACKEND}
          </small>
          <small className="text-center d-block">
            © 2020 - {new Date().getFullYear()}, ICT Campus, M1k3, Manuel Ruwe,
            Levin Biçer, Sven Zemp. Lara Saurer
          </small>
        </div>
      </footer>
    </>
  );
}

function AppVersion() {
  if (APP_VERSION.FRONTEND.IS_NIGHTLY) {
    return (
      <b className="text-danger">
        <CpuIcon className="mr-2" />
        Entwicklungsversion
      </b>
    );
  }

  return <span>App Version:</span>;
}
